"use client";

import { momentWalk, runs } from "./checkrideV6DemoData";

/**
 * The exam is a flight, not a questionnaire. Each stage is a place in the trip, and the
 * examiner stays there until that part of the flight is settled. Turn counts are real.
 */
export default function V6FlightWalk() {
  const max = Math.max(...momentWalk.map((m) => m.turns));
  const total = momentWalk.reduce((a, m) => a + m.turns, 0);

  return (
    <section id="flight" className="py-24 md:py-32 px-6 bg-white border-t border-hairline/60">
      <div className="max-w-4xl mx-auto">
        <span className="text-[11px] font-semibold tracking-wider uppercase text-accent">
          The shape of the exam
        </span>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-[-0.02em] text-ink">
          It walks one flight, from the FBO to the destination
        </h2>
        <p className="mt-4 text-ink-soft leading-relaxed max-w-2xl">
          Not a list of topics. The examiner takes a single cross-country trip and works
          through it in order — the paperwork on the counter, the aeroplane on the ramp,
          the weather, the route — asking what a real DPE would ask at that point. It
          leaves a stage when that part of the flight is settled, not when a timer says so.
        </p>

        <div className="mt-12 space-y-2.5">
          {momentWalk.map((m) => (
            <div key={m.index} className="flex items-center gap-4">
              <div className="w-6 shrink-0 text-right text-xs font-semibold text-ink-faint tabular-nums">
                {m.index}
              </div>
              <div className="w-full">
                <div className="flex items-baseline justify-between gap-4 mb-1.5">
                  <span className="text-sm text-ink">{m.label}</span>
                  <span className="shrink-0 text-xs text-ink-faint tabular-nums">
                    {m.turns} {m.turns === 1 ? "exchange" : "exchanges"}
                  </span>
                </div>
                <div className="h-2 rounded-full bg-ground-alt overflow-hidden">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-sky-500 to-violet-500"
                    style={{ width: `${Math.max((m.turns / max) * 100, 3)}%` }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-sm text-ink-faint">
          {total} exchanges to reach {runs.find((r) => r.sessionId)?.reached ?? "the destination"}.
          All three candidates walked all {momentWalk.length} stages.
        </p>
      </div>
    </section>
  );
}
